import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { HotlineClientDetailLayoutSkeleton } from '@/feature/hotline/client/detail/component/HotlineClientDetailLayout';
import { HotlineClientDetailMeetingListSkeleton } from '@/feature/hotline/client/detail/meeting/component/HotlineClientDetailMeetingList';
import { hotlineClientDetailMeetingViewStyle } from '@/feature/hotline/client/detail/meeting/page/style';
/**
 * 匿名コンサルホットライン 面談実施（スケルトン表示）
 */
export const HotlineClientDetailMeetingViewSkeleton = () => {
    const style = hotlineClientDetailMeetingViewStyle();
    return (_jsxs(HotlineClientDetailLayoutSkeleton, Object.assign({ activeStepIndex: 2, classNames: { childrenWrap: style.base() }, wrapContentCard: false }, { children: [_jsx(Skeleton, { className: 'w-full h-[52px]' }), _jsx(HotlineClientDetailMeetingListSkeleton, {})] })));
};
